import { PlankPatternForm } from "./PlankPattern.form";

/** One tile photo is enough; the generator reads the tile's proportions and which way it faces. */
export const TrianglePatternForm = (props) => (
  <PlankPatternForm
    {...props}
    pattern="triangle"
    width={{ value: "12.4", min: 5, max: 40, labelKey: "TILE_WIDTH" }}
    height={{ value: "10.8", min: 5, max: 40, labelKey: "TILE_HEIGHT" }}
  />
);
